import { useState } from "react";
import "./detailpage.css";
import sagittalsawblade from "../../images/Sagittal Blade.jpg";
import hipudrapebanner from "../../images/saggital-blade-new-baaner.jpg";
import { FaWhatsapp } from "react-icons/fa";
import sagittalbladesingle from "../../images/shortandlongbladeoption.jpg";
import sagittalbladedouble from "../../images/multipletooth configuration.jpg";
import typeone from "../../images/typeone.jpg"
import typetwo from "../../images/typetwo.jpg"
import typethree from "../../images/typethree.jpg"
import typefour from "../../images/typefour.jpg"
import typefive from "../../images/typefive.jpg"
import longandshort from "../../images/longandshortblade.jpg"
import multipletooth from "../../images/multiple-tooth.jpg"
import oneloop from "../../images/oneloop.jpeg"
import twoloop from "../../images/twoloop.jpg"
import threeloop from "../../images/threeloop.jpg"
import bladebox from "../../images/saggital-box-col.jpg"
import packagewrapper from "../../images/package-box.jpeg"
import multipletools from "../../images/multiple-ttols.jpeg"
const whatsappNumber = "+919619065205";
const whatsappMessage = `https://wa.me/+919619065205?text=Hi! I'm interested in your medical products. Please provide more information.`;

const SagittalBlade = () => {
  const [activeImage, setActiveImage] = useState(bladebox);
const [isThumbActive, setIsThumbActive] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className="page-sagittal">
      {/* <nav className="breadcrumbs">
        <a href="/">Home</a> <span>›</span> <a href="/products">Products</a>
        <span>›</span> <a href="/products/surgical-consumables">Orthopaedics</a>
        <span>›</span>
        Sagittal Saw Blades
      </nav> */}

      {/* Hero Section */}
      <section
        className="homepage-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${hipudrapebanner})`,
        }}
      >
        <h1 className="homepage-hero-title">Sagittal Blade</h1>
        <p className="homepage-hero-subtext">
          Precision-engineered blades for orthopaedic joint replacement, trauma
          and spine surgery, compatible with multiple sagittal saw handpiece
          couplings.
        </p>
        <div className="homepage-hero-buttons">
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Quote
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Brochure
          </a>
        </div>
      </section>
      <section className="product-header">
<div className="media-card">
  <div className={`main-image ${isThumbActive ? "activate-mode" : ""}`}>
    <img
      src={activeImage}
      alt="Sagittal Saw Blades - Sabiote Healthcare"
    />
  </div>

  <div className="thumb-row">
    <div
      className="thumb"
      onClick={() => {
        setActiveImage(twoloop);
        setIsThumbActive(true);
      }}
    >
      <img src={twoloop} alt="" />
    </div>

    <div
      className="thumb"
      onClick={() => {
        setActiveImage(oneloop);
        setIsThumbActive(true);
      }}
    >
      <img src={oneloop} alt="" />
    </div>

    <div
      className="thumb"
      onClick={() => {
        setActiveImage(packagewrapper);
        setIsThumbActive(true);
      }}
    >
      <img src={packagewrapper} alt="" />
    </div>

    <div
      className="thumb"
      onClick={() => {
        setActiveImage(multipletools);
        setIsThumbActive(true);
      }}
    >
      <img src={multipletools} alt="" />
    </div>
  </div>
</div>



        <div>
          {/* <div className="badge-row">
            <span className="badge badge--primary">Large &amp; Small Bone</span>
            <span className="badge">Multiple coupling types</span>
            <span className="badge">Custom tooth patterns</span>
          </div> */}
          <div class="feature-grid">
  <div class="feature-card">
    <h4>Large & Small Bone</h4>
    <p>Designed for precision cutting across bone sizes</p>
  </div>

  <div class="feature-card">
    <h4>Multiple Coupling Types</h4>
    <p>Compatible with various surgical systems</p>
  </div>

  <div class="feature-card">
    <h4>Custom Tooth Patterns</h4>
    <p>Optimized cutting performance</p>
  </div>
</div>

          <h1>Sagittal Saw Blades</h1>
          <p className="subtitle">
            Precision-engineered blades for orthopaedic joint replacement,
            trauma and spine surgery, compatible with multiple sagittal saw
            handpiece couplings.
          </p>
          <div className="meta-row">
            <div>
              <span className="meta-label">Material:</span> Medical grade
              stainless steel
            </div>
            <div>
              <span className="meta-label">Applications:</span> Large &amp;
              small bone cutting
            </div>
            <div>
              <span className="meta-label">Compatibility:</span> Multiple
              coupling types*
            </div>
          </div>
          <div className="chip-row">
            <div className="chip">
              <img
                src={longandshort}
                alt="Sagittal Saw Blades - Sabiote Healthcare"
              />
              Long &amp; short blade options
            </div>
            <div className="chip">
              <img
                src={multipletooth}
                alt="Sagittal Saw Blades - Sabiote Healthcare"
              />
              Multiple tooth configurations
            </div>
            <div className="chip">
              <img
                src={threeloop}
                alt="Sagittal Saw Blades - Sabiote Healthcare"
              />
              OEM / private-label ready
            </div>
            <div className="chip">
              <img
                src={sagittalsawblade}
                alt="Sagittal Saw Blades - Sabiote Healthcare"
              />
              Custom geometries on request
            </div>
          </div>
          <p className="excerpt">
            Our sagittal saw blades are designed for clean, controlled bone
            resections with optimised tooth geometry for fast cutting, smooth
            surfaces and reduced heat generation. With a range of couplings,
            lengths, widths and kerfs, they integrate seamlessly into existing
            orthopaedic power systems.
          </p>
          <div className="cta-row">
            <a
              href="https://wa.me/+919619065205?text=Hello! I'm interested in bulk procurement of Sagittal Blades. Please share more details."
              className="btn btn-primary"
            >
              Configure &amp; Request Quote
              <svg viewBox="0 0 20 20" fill="none">
                <path
                  d="M5 10h8m0 0-3-3m3 3-3 3"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </a>
            <a href="#downloads" className="btn btn-outline">
              Download Blade Catalog
            </a>

            <span className="note">OEM / dealer enquiries welcome.</span>
          </div>
          <div className="pill-label">
            <span>Key Procedures:</span> TKA, THA, revision arthroplasty,
            trauma, spine, small bone
          </div>
          <div>
            <div className="card-subtitle">Coupling Interfaces</div>
            <p className="note">
              Visual examples of available coupling types. Match your handpiece
              to the closest coupling shape below or send us a photo/drawing for
              confirmation.
            </p>
            <div className="coupling-strip couling-sggital-bx">
              <div className="coupling-item">
                <img
                  src={typeone}
                  alt="Sagittal Saw Blades - Sabiote Healthcare"
                />
                Type A
              </div>
              <div className="coupling-item">
                <img
                  src={typetwo}
                  alt="Sagittal Saw Blades - Sabiote Healthcare"
                />
                Type B
              </div>
              <div className="coupling-item">
                <img
                  src={typethree}
                  alt="Sagittal Saw Blades - Sabiote Healthcare"
                />
                Type C
              </div>
              <div className="coupling-item">
                <img
                  src={typefour}
                  alt="Sagittal Saw Blades - Sabiote Healthcare"
                />
                Type D
              </div>
              <div className="coupling-item">
                <img
                  src={typefive}
                  alt="Sagittal Saw Blades - Sabiote Healthcare"
                />
                Custom
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content-grid">
        <div>
          <article className="card">
            <div className="card-subtitle">Highlights</div>
            <h2>Key Features &amp; Cutting Performance</h2>
            <p>
              Developed for OEM-level performance, these blades combine precise
              coupling, engineered tooth profiles and consistent metallurgy to
              deliver a controlled cut and predictable feel in bone.
            </p>
            <div className="feature-grid">
              <div className="feature-item">
                <div className="feature-title">Multi-system couplings</div>
                <div className="feature-text">
                  Blade hubs are machined in different coupling types to match a
                  wide range of sagittal saw handpieces. Compare your handpiece
                  to our coupling gallery or share a photo for selection
                  support.
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-title">Optimised tooth geometry</div>
                <div className="feature-text">
                  Tooth forms engineered for fast cutting with reduced chatter,
                  efficient chip evacuation and controlled kerf to support
                  accurate resections and implant seating.
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-title">Length &amp; width options</div>
                <div className="feature-text">
                  Long and short blade families covering common widths for large
                  bone, small bone and specialty applications.
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-title">Controlled kerf thickness</div>
                <div className="feature-text">
                  Tight tolerances on blade thickness help balance stiffness,
                  heat generation and bone conservation.
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-title">
                  Surface finish &amp; hardness
                </div>
                <div className="feature-text">
                  Hardened stainless steel with fine surface finish for
                  durability and low friction along cutting guides.
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-title">Custom &amp; private-label</div>
                <div className="feature-text">
                  Tailor couplings, lengths, kerfs, tooth patterns and
                  marking/packaging to your own OEM or house brand.
                </div>
              </div>
            </div>
          </article>
          <article className="card">
            <div className="card-subtitle">Overview</div>
            <h2>Product Description</h2>
            <p>
              Sagittal saw blades are critical cutting tools in orthopaedic
              surgery, used across joint replacement, fracture fixation, bone
              grafting and spinal procedures. They must cut efficiently while
              limiting heat build-up and preserving bone quality.
            </p>
            <p>
              Our blades are manufactured from medical-grade stainless steel
              using CNC machining and precision grinding to ensure consistent
              tooth form, kerf and oscillation behaviour from blade to blade.
              Coupling ends are profiled to interface reliably with the
              corresponding sagittal saw handpiece coupling type, helping
              minimise play at the connection and transfer power efficiently
              into the cut.
            </p>
            <p>
              Available in long and short versions with different widths,
              thicknesses and tooth densities, the portfolio supports both large
              bone (hip, knee) and smaller bone work (hand, foot, maxillofacial)
              as well as customised geometries for specialised procedures.
            </p>
          </article>
          <article className="card">
            <div className="card-subtitle">Portfolio</div>
            <h2>Blade Sizes &amp; Tooth Configurations</h2>
            <p>
              Typical size range
            </p>
            <table className="spec-table">
              <tr>
                <th>Family</th>
                <th>Example Dimensions (L × W × T)</th>
              </tr>
              <tr>
                <td>Short – Large Bone</td>
                <td>70–90 mm length × 9–13 mm width × 0.8–1.27 mm thickness</td>
              </tr>
              <tr>
                <td>Long – Large Bone</td>
                <td>
                  100–120 mm length × 13–20 mm width × 1.0–1.27 mm thickness
                </td>
              </tr>
              <tr>
                <td>Small Bone / Micro</td>
                <td>10–30 mm length × 3–6 mm width × 0.4–0.8 mm thickness</td>
              </tr>
            </table>
            <p className="note">
              Replace the above with your actual blade catalogue dimensions, or
              link a full size matrix in the Resources section.
            </p>
            <p>Tooth options (examples):</p>
            <ul>
              <li>
                <strong>Coarse cut</strong> – aggressive removal for large bone
                resections.
              </li>
              <li>
                <strong>Standard / medium cut</strong> – balanced control and
                speed for most joint procedures.
              </li>
              <li>
                <strong>Fine cut</strong> – smoother finish and reduced chip
                size for delicate work.
              </li>
              <li>
                <strong>Custom profiles</strong> – optimised for specific
                guides, implant systems or surgeon preferences.
              </li>
            </ul>
          </article>
          <article className="card">
            <div className="card-subtitle">Couplings</div>
            <h2>Handpiece Coupling Types</h2>
            <p>
              Blades are available with several standard coupling types to
              interface with a wide range of sagittal saw handpieces. Match the
              coupling visually or share a photo of your handpiece and we will
              advise the best fit.
            </p>
            <table className="spec-table">
              <tr>
                <th>Coupling Type</th>
                <th>Description / Typical Use</th>
              </tr>
              <tr>
                <td>Type A</td>
                <td>
                  Common large bone sagittal saw coupling. See “Type A” image in
                  the coupling gallery above.
                </td>
              </tr>
              <tr>
                <td>Type B</td>
                <td>
                  Alternative large bone coupling profile used on many hospital
                  systems.
                </td>
              </tr>
              <tr>
                <td>Type C</td>
                <td>
                  Compact coupling often used on smaller bone or multi-purpose
                  handpieces.
                </td>
              </tr>
              <tr>
                <td>Type D</td>
                <td>
                  Specialty or legacy system coupling – available on request.
                </td>
              </tr>
              <tr>
                <td>Custom</td>
                <td>
                  Developed based on drawing, sample or customer specification.
                </td>
              </tr>
            </table>
            <p className="note">
              Coupling types are shown in outline form only and are not
              associated with or endorsed by any specific third-party brand or
              manufacturer.
            </p>
          </article>
          <article className="card">
            <div className="card-subtitle">Clinical Use</div>
            <h2>Indications &amp; Procedures</h2>
            <p>Sagittal saw blades are intended for bone cutting in:</p>
            <ul>
              <li>Total hip and knee arthroplasty (primary and revision)</li>
              <li>Unicompartmental knee procedures</li>
              <li>Trauma and fracture fixation surgeries</li>
              <li>Spinal procedures requiring controlled bone cuts</li>
              <li>
                Small bone orthopaedics (hand, foot) – with micro blade series
              </li>
              <li>
                Other musculoskeletal procedures as determined by the surgeon
              </li>
            </ul>
            <p className="note">
              Use only by trained orthopaedic surgeons and theatre staff
              familiar with powered cutting systems.
            </p>
          </article>
          <article className="card">
            <div className="card-subtitle">Safety</div>
            <h2>Use, Handling &amp; Safety Considerations</h2>
            <ul>
              <li>
                Inspect each blade before use for straightness, tooth integrity
                and secure coupling fit.
              </li>
              <li>
                Ensure correct coupling type and proper locking prior to
                starting the saw.
              </li>
              <li>
                Use appropriate irrigation where required to help manage heat at
                the bone interface.
              </li>
              <li>
                Do not bend, twist or lever with the blade; use only for its
                intended cutting purpose.
              </li>
              <li>
                Follow facility protocols for sterilisation (for reusable
                blades) or disposal (for single-use blades).
              </li>
            </ul>
            <p className="note">
              Always refer to the Instructions for Use and the powered handpiece
              documentation for speed, pressure and irrigation recommendations.
            </p>
          </article>
          <article className="card" id="faq">
            <div className="card-subtitle">Support</div>
            <h2>Frequently Asked Questions</h2>
            <div className="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(0)}>
                Can you match a blade from our existing supplier?
                <span className={`faq-arrow ${openIndex === 0 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 0 && (
                <div className="faq-a">
                  Yes. With a drawing, sample or reference code, we can match
                  key parameters such as coupling shape, length, width,
                  thickness and tooth pattern, and offer blades under Sabiote or
                  your own brand.
                </div>
              )}
            </div>
            <div className="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(1)}>
                Do you offer both single-use and reusable blades?
                <span className={`faq-arrow ${openIndex === 1 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 1 && (
                <div className="faq-a">
                  Blade construction and packaging can be configured either for
                  sterile single-use or for reusable sterilisation cycles,
                  depending on your requirement and local regulations.
                </div>
              )}
            </div>
            <div className="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(2)}>
                What information is needed to specify a custom blade?
                <span className={`faq-arrow ${openIndex === 2 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 2 && (
                <div className="faq-a">
                  Typically: coupling type (or photo), blade length, width,
                  thickness, tooth density/profile and any preferred coatings,
                  plus intended procedure(s) and annual quantities.
                </div>
              )}
            </div>
            <div className="faq-item">
              <div className="faq-q" onClick={() => toggleFaq(3)}>
                Can you supply private-label packaging?
                <span className={`faq-arrow ${openIndex === 3 ? "open" : ""}`}>
                  ▼
                </span>
              </div>
              {openIndex === 3 && (
                <div className="faq-a">
                  We can provide blades with your logo, reference codes and
                  packaging artwork, subject to artwork approval and minimum
                  order quantities.
                </div>
              )}
            </div>
          </article>
        </div>
        <aside>
          <div className="card" id="quote">
            <div className="card-subtitle">Ordering</div>
            <h2>How to Specify Your Blade</h2>
            <p className="side-card-text">
              Use the configuration below when requesting a quotation or placing
              an order:
            </p>
            <table className="spec-table">
              <tr>
                <th>Step 1 – Coupling</th>
                <td>
                  Select coupling type (A / B / C / D / Custom) and, if
                  possible, share a handpiece photo.
                </td>
              </tr>
              <tr>
                <th>Step 2 – Length</th>
                <td>Specify long or short series and target length (mm).</td>
              </tr>
              <tr>
                <th>Step 3 – Width</th>
                <td>
                  Choose blade width (mm) based on the cut and cutting guide.
                </td>
              </tr>
              <tr>
                <th>Step 4 – Thickness</th>
                <td>
                  Define thickness / kerf (mm) for the desired balance of
                  stiffness and bone conservation.
                </td>
              </tr>
              <tr>
                <th>Step 5 – Tooth</th>
                <td>
                  Select tooth style (coarse / standard / fine / custom
                  pattern).
                </td>
              </tr>
              <tr>
                <th>Step 6 – Use Type</th>
                <td>Indicate single-use sterile or reusable configuration.</td>
              </tr>
              <tr>
                <th>Step 7 – Branding</th>
                <td>
                  Choose Sabiote branding or your own OEM / private-label.
                </td>
              </tr>
            </table>
            <div className="side-divider"></div>
            <p className="side-card-heading">Ready to configure?</p>
            <p className="side-card-text">
              Share your blade matrix or reference list, and our engineering
              team will map it to Sabiote part numbers and provide a
              consolidated offer.
            </p>
            <a href="/contact" className="btn btn-outline">
              Send Requirements
            </a>
          </div>
          <div className="card">
            <div className="card-subtitle">OEM</div>
            <h2>OEM &amp; Custom Manufacturing</h2>
            <p className="side-card-text">
              As an OEM manufacturer, we support:
            </p>
            <ul>
              <li>
                Blade designs to your drawings or matched to existing blade
                geometry.
              </li>
              <li>Coupling types aligned to your preferred power systems.</li>
              <li>
                Engraving/marking of your logo, REF/LOT and UDI (where
                required).
              </li>
              <li>Neutral or fully customised packaging and IFUs.</li>
            </ul>
            <p className="note">
              NDA-based development can be provided for strategic partners.
            </p>
          </div>
          <div className="card">
            <div className="card-subtitle">Quality</div>
            <h2>Quality &amp; Compliance</h2>
            <p className="side-card-text">
              Blades are produced under controlled processes with traceable
              materials and in￾process inspection.
            </p>
            <div className="pill-stack">
              <div className="pill">Medical-grade stainless steel</div>
              <div className="pill">Process validation &amp; inspection</div>
              <div className="pill">ISO 13485-compliant QMS*</div>
              <div className="pill">
                Regulatory registrations as applicable*
              </div>
            </div>
            <p className="note">
              *Update statements according to your current certifications and
              registrations.
            </p>
          </div>
          <div className="card" id="downloads">
            <div className="card-subtitle">Resources</div>
            <h2>Downloads</h2>
            <ul class="download-list">
              <li>
                <a href="sagittal-blades-catalog.pdf" class="download-link">
                  <svg viewBox="0 0 20 20" fill="none">
                    <path
                      d="M5 9v6.5A1.5 1.5 0 0 0 6.5 17h7A1.5 1.5 0 0 0 15 15.5V9"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10 3v9m0 0 3-3.2M10 12 7 8.8"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Sagittal Saw Blades – Catalog (PDF)
                </a>
              </li>
              <li>
                <a
                  href="sagittal-blades-coupling-guide.pdf"
                  class="download-link"
                >
                  <svg viewBox="0 0 20 20" fill="none">
                    <path
                      d="M4 14.5V5.5A1.5 1.5 0 0 1 5.5 4h9"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                    />
                    <path
                      d="M6 9h3m-3 3h5m3.5-8v10A1.5 1.5 0 0 1 13 15.5H6"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                    />
                  </svg>
                  Coupling Selection Guide
                </a>
              </li>
              <li>
                <a href="sagittal-blades-ifu.pdf" class="download-link">
                  <svg viewBox="0 0 20 20" fill="none">
                    <circle
                      cx="10"
                      cy="10"
                      r="7"
                      stroke="currentColor"
                      strokeWidth="1.4"
                    />
                    <path
                      d="M10 6.3v4.1"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                    />
                    <circle cx="10" cy="13.4" r="0.7" fill="currentColor" />
                  </svg>
                  Instructions for Use (IFU)
                </a>
              </li>
            </ul>
          </div>
          <div className="card" id="contact">
            <div className="card-subtitle">Enquiries</div>
            <h2>Talk to Our Engineering &amp; Sales Team</h2>
            <p className="side-card-text">
              Send us your current blade list, reference drawings or handpiece
              photos and we’ll propose equivalent or improved configurations.
            </p>
            <p className="side-card-text">
              Email: <a href="mailto:sales@sabiote.in">sales@sabiote.in</a>
              <br />
              <br />
              <a
                href={whatsappMessage}
                target="_blank"
                rel="noopener noreferrer"
                className="callback-btn"
              >
                <FaWhatsapp /> Book a Callback
              </a>
            </p>
          </div>
        </aside>
      </section>
      <footer className="footer-note">
        <strong>Disclaimer:</strong> Product availability, specifications and
        coupling options may vary by country and over time. Sagittal saw blades
        are intended for use by trained healthcare professionals only. Always
        refer to the product labelling, Instructions for Use and powered
        handpiece documentation before use.
      </footer>
    </div>
  );
};

export default SagittalBlade;
